// extracted by mini-css-extract-plugin
module.exports = {"controls":"TestimonalsSection_controls__F1lo0","card":"TestimonalsSection_card__1_ZME"};